import { Grid2 } from "@mui/material"

export function ReportHeader({ columns }) {
    return (
        <Grid2
            container
            sx={{
                bgcolor: "#f5f5f5",
                border: "1px solid #ddd",
                width: "100%",
                padding: "4px",
                alignItems: "center",
                minWidth: "100%",
            }}
        >
            {columns.map((column, i) => (
                <Grid2 key={i} size={column.size} sx={{ padding: "4px" }}>
                    {column.title}
                </Grid2>
            ))}
        </Grid2>
    )
}
